import NewPropertyModal from "./NewPropertyModal";

export default NewPropertyModal;
